import { useQuery } from 'react-query';
import { useAppSession } from '../contexts/AppSessionContext';
import { getLatestM2mSnapshot, M2mSnapshot } from '../services/m2mService';

export function useLatestM2m() {
  const { user: sessionUser, firebaseReady } = useAppSession();
  const accountId = sessionUser?.accountId || '';

  return useQuery<M2mSnapshot | null>({
    queryKey: ['m2m', 'latest', accountId],
    queryFn: () => getLatestM2mSnapshot(accountId),
    enabled: !!accountId && firebaseReady,
    staleTime: 5 * 60 * 1000,
  });
}
